import { USER_KEY } from './core/auth/constants';
import { GlobalErrorHandler } from './core/error-handler/global-error.handler';

export function errorHandlerFactory() {
    return new GlobalErrorHandler();
}
const getRelesaeStage = () => {
    const domain = window.location.hostname;

    switch (domain) {
        case 'espp.epgins.com':
        case 'ppp.cnhinsurance.com':
            return 'production';
        //model clientid
        case 'espp-integration-model.epgins.com':
        case 'espp-model.epgins.com':
            return 'model';
        //default to dev okta env
        default:
            return 'dev';
    }

}

export const bugsnagConfig = {
    apiKey: '3180455312abcbbebf78cad9c07fa830',
    releaseStage: getRelesaeStage(),
    onError: function (event) {
        const user = sessionStorage.getItem(USER_KEY)
            ? JSON.parse(sessionStorage.getItem(USER_KEY) || '')
            : null;
        user &&
            event.setUser(
                user.id,
                user.email,
                `${user.first_name} ${user.last_name}`
            );
    },
    enabledReleaseStages: ['production', 'model'],
    // Reduce session tracking during navigation to prevent multiple calls
    autoTrackSessions: false,
};